<template>
  <hint-wrap :text="'Mail cycle progress: '+ progressValue(mail).hint">
  <template slot="content">

  <div class="progress-container">
    <div
      class="status-progress"
      v-if="isProgressVisible(mail) && progressValue(mail).value !== '0%' && progressValue(mail).value !== '100%'"
    >
      <span :style="{ width: progressValue(mail).value }">
        <span class="sm-linear-progress"></span>
      </span>
    </div>

    <div class="completed-status" v-if="progressValue(mail).value === '100%'">
      <span class="sm-completed-progress">
        <include-svg :name="'svg-filled-completed-request'" />
      </span>
    </div>
  </div>
</template>
</hint-wrap>

</template>

<script>
import HintWrap from '@/components/HintWrap';


export default {
  name: 'status-progress',
  props: {
    mail: {
      type: Object,
    },
  },
  components: {
    'hint-wrap': HintWrap,
  },
  methods: {
    isProgressVisible(curMail) {
      return curMail.status !== "new"
    },
    progressValue(curMail) {
      let val = 0;
      let date = null;

      if (curMail.is_pick_up_complete || curMail.is_shred_complete || curMail.is_forward_complete || curMail.mark_as_pick_up_complete || curMail.is_check_deposit_completed || curMail.signed_on) {
        val = 100;
        date = curMail.pick_up_scheduled_at || curMail.trashed_date || curMail.forwarded_at || curMail.check_deposited_date || curMail.signed_on;
        return {
          value: `${val}%`,
          date: (date ? `at ${date}` : ""),
          hint: `${val}%` + (date ? ` at ${this.$moment(date).format('D MMMM, YYYY HH:mm')}` : "")
        };
      }

      if (curMail.is_pick_up && curMail.pick_up_scheduled_at) {
        val = 50;
      }

      if (curMail.is_forward_requested || curMail.is_shred_requested || curMail.mark_as_pick_up_requested || curMail.is_check_deposit_requested || curMail.is_junk) {
        val = 50;
      }

      if(curMail.picture_requested_at){
        val += 10

      }
      if(curMail.picture_added_at){
        val += 10
      }

      if(curMail.is_scan_requested || curMail.is_same_day_scan_requested || curMail.is_two_days_scan_requested){
        val += 10

      }
      if(curMail.is_scan_complete){
        val += 10
      }

      return {
        value: `${val}%`,
        date: null,
        hint: `${val}%`
      };
    },

  },

};
</script>

<style scoped lang="scss">

.progress-container{
  display: inline-block;
  position: relative;
  cursor: pointer;
  .status-progress {
    width: 40px;
    height: 14px;
    padding: 3px;
    border-radius: 10px;
    background: #DBDADD;
    margin: 2px 8px 2px 0px;

    span {
      display: block;
      overflow: hidden;
      .sm-linear-progress {
        display: block;
          width: 34px;
          height: 8px;
          border-radius: 100px;
          background: linear-gradient(270deg, #7A4BA2 0%, #4B1B7A 100%),
          linear-gradient(0deg, #7A4BA2, #7A4BA2);
        }
    }

  }

  .completed-status {
    width: 18px;
    height: 18px;
    padding: 3px;
    border-radius: 10px;
    background: #DBDADD;
    margin: 2px 8px 2px 0px;

    .sm-completed-progress {
      display: grid;
      place-items: center;
      svg {
        width: 12px;
        height: 12px;
        padding: 3.5px, 2.5px, 3.5px, 2.5px

      }
    }

  }

}
</style>

